import React from 'react';
import Descriptions from 'antd/es/descriptions';
import { AuthenticatedContextType } from '../../context/AuthenticatedContext';
import Parts from '../../models/data/Parts';
import {
  contentStyle,
  dataDispWidth,
  labelStyle,
  userContentStyle,
  userLabelStyle,
} from '../../css/style';
import { dateformat } from '../date-range';

interface DataProps {
  userdata: AuthenticatedContextType;
  data: Parts | undefined;
}

const DataDisp: React.FC<DataProps> = ({ userdata, data }) => {
  const customerName = userdata.loginCustomer?.customerName ?? '';
  const corporateCode = userdata.loginCustomer?.corporateCode ?? '';

  return (
    <div>
      {/* ユーザ情報 */}
      <Descriptions
        bordered
        column={3}
        labelStyle={userLabelStyle}
        contentStyle={userContentStyle}
        style={{ marginBottom: '10px', width: dataDispWidth.userInfo }}
      >
        <Descriptions.Item label="ユーザ名" span={3}>
          {`${corporateCode} ◇ ${customerName}`}
        </Descriptions.Item>
      </Descriptions>
      {/* 部品情報1 */}
      <Descriptions
        // title=""
        bordered
        column={3}
        contentStyle={contentStyle}
        labelStyle={labelStyle}
        style={{ marginBottom: '10px', width: dataDispWidth.partsDetail }}
      >
        <Descriptions.Item label="機器ID" span={3}>
          {data?.mstId ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="部品ID" span={3}>
          {data?.partsId ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="品名" span={3}>
          {data?.partsName ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="形式" span={3}>
          {data?.type ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="品番" span={3}>
          {data?.partsNo ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="製造者" span={3}>
          {data?.makerName ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="数量" span={3}>
          {`${data?.qty ?? ''} ${data?.unit ?? ''}`}
        </Descriptions.Item>
        <Descriptions.Item label="属性" span={1}>
          {data?.partsClass ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="用途" span={2}>
          {data?.partsUse ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="点検項目" span={1}>
          {data?.insItem ?? ''}
        </Descriptions.Item>
        <Descriptions.Item label="保守種別" span={2}>
          {data?.mainteType ?? ''}
        </Descriptions.Item>
      </Descriptions>
      <Descriptions
        // title=""
        bordered
        column={2}
        contentStyle={contentStyle}
        labelStyle={labelStyle}
        style={{ marginBottom: '10px', width: dataDispWidth.partsDetail }}
      >
        <Descriptions.Item label="取替周期(年)" span={1}>
          {data?.repYear != null ? `${data?.repYear} 年` : ''}
        </Descriptions.Item>
        <Descriptions.Item label="取替周期" span={1}>
          {data?.rep}
        </Descriptions.Item>
        <Descriptions.Item label="交換日" span={2}>
          {dateformat(data?.changeDate)}
        </Descriptions.Item>
        <Descriptions.Item label="備考" span={2}>
          {data?.biko}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default DataDisp;
